import XButton from "../common/XButton";

const TIPS = [
  {
    icon: "fa-exclamation-triangle",
    variant: "warning",
    text: "AI-generated content may contain hallucinated data. Always verify facts, dates, and figures against the original medical records before finalizing.",
  },
  {
    icon: "fa-pencil",
    variant: "neutral",
    text: "Edits you make here are saved as plain text. The final demand document is regenerated from these sections, so make sure your changes read correctly in context.",
  },
  {
    icon: "fa-comments",
    variant: "info",
    text: "Use revision comments to request AI rewrites of a section. The AI will incorporate your instructions while preserving the rest of the document.",
  },
];

const variantItemClasses = {
  warning: "bg-warning-surface border-l-warning-light",
  neutral: "bg-surface-alt border-l-border",
  info: "bg-primary-surface border-l-primary-light-2",
};

const variantIconClasses = {
  warning: "text-warning",
  neutral: "text-subtle",
  info: "text-primary",
};

const popoverClasses =
  "absolute top-[calc(100%+8px)] right-0 z-[1000] w-95 " +
  "bg-surface border border-border rounded-[calc(var(--spacing)*2.5)] " +
  "shadow-[0_8px_24px_rgba(0,0,0,0.12)] p-4";

const headerClasses = "flex items-center justify-between mb-3";

const titleClasses = "font-action-sans text-base font-bold text-content m-0!";

const closeClasses =
  "bg-transparent border-0 text-subtle cursor-pointer " +
  "text-sm p-1 hover:text-content";

const listClasses = "list-none m-0! p-0 flex flex-col gap-2.5";

const itemBaseClasses =
  "flex items-start gap-2.5 text-[calc(var(--spacing)*3.25)] leading-normal text-label " +
  "py-2.5 px-3 rounded-md border-l-[calc(var(--spacing)*0.75)]";

const itemIconBase = "shrink-0 mt-0.5 text-sm";

const DemandStudioTipsPopover = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className={popoverClasses}>
      <div className={headerClasses}>
        <h6 className={titleClasses}>Tips</h6>
        <XButton variant="close" className={closeClasses} onClick={onClose} aria-label="Close tips">
          <i className="fa fa-times" />
        </XButton>
      </div>
      <ul className={listClasses}>
        {TIPS.map((tip, index) => (
          <li key={index} className={`${itemBaseClasses} ${variantItemClasses[tip.variant]}`}>
            <i className={`fa ${tip.icon} ${itemIconBase} ${variantIconClasses[tip.variant]}`} />
            <span>{tip.text}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DemandStudioTipsPopover;
